export default __webpack_public_path__ + "static/media/Logo.417766f0.png";